
export const siteGuardUserPermissions = [
    {
        name: "Monitoring",
        route: "monitoring",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transactions",
        route: "transactions",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Dashboard",
        route: "dashboard",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Alarm Viewer",
        route: "alarms",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    // {
    //     name: "Modules",
    //     route: "modules",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // },
    // {
    //     name: "Scheduled Tours",
    //     route: "scheduled-tours",
    //     showListItem: true,
    //     addElements: true,
    //     deleteElements: true,
    //     updateElements: true
    // }
    {
        name: "Reports",
        route: "reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Transaction",
        route: "transaction-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "transaction-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Reports",
        route: "time-attendance-reports",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
    {
        name: "Time & Attendance",
        route: "time-attendance-report",
        showListItem: true,
        addElements: true,
        deleteElements: true,
        updateElements: true
    },
]
